var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStopTramWaltti = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 8,
  x: 14.5,
  y: 22,
  fill: "#333",
  rx: 1.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 13,
  r: 11
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.4 21H9.6A1.6 1.6 0 0 1 8 19.4V6.6A1.6 1.6 0 0 1 9.6 5h12.8A1.6 1.6 0 0 1 24 6.6v12.8a1.6 1.6 0 0 1-1.6 1.6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.772 17.25v-6.853c0-.583-.473-2.12-1.056-2.12h-1.827l.532-1.108h.895V6.6h-4.632v.568h.905l.532 1.108h-1.837c-.583 0-1.056 1.537-1.056 2.12v6.853c0 .583.473 1.055 1.056 1.056l-.79 1.095h1.155l.79-1.095h3.122l.79 1.095h1.154l-.789-1.095c.583 0 1.056-.473 1.056-1.056m-4.56-10.081h1.586l-.532 1.108h-.521zm-.889 1.782h3.354v.567h-3.354zm-1.34 7.532a.577.577 0 1 1 1.154 0 .577.577 0 0 1-1.155 0m5.457.578a.577.577 0 1 1 0-1.155.577.577 0 0 1 0 1.155m.577-2.27c0 .137-.073.256-.178.292-.42.141-1.537.255-2.84.255s-2.418-.114-2.838-.255c-.106-.036-.179-.155-.179-.291v-4.408c0-.167.108-.302.242-.302h5.552c.133 0 .242.135.242.302z"
})));
export { SvgStopTramWaltti as ReactComponent };